export default __webpack_public_path__ + "static/media/snowtree2.e1802fd3.png";